import { useState } from "react";
import "./ImageRow.css";

const ImageRow = ({images, alt}) => {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <div>
      <div className="image-row">
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={alt}
            className="image-item"
            onClick={() => setSelectedImg(img)}
            style={{ cursor: "pointer" }}
          />
        ))}
      </div>

      {selectedImg && (
        <div className="modal" onClick={() => setSelectedImg(null)}>
          <img src={selectedImg} alt="Powiększony" className="modal-img" />
        </div>
      )}
    </div>
  );
};

export default ImageRow;
